import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="nested-form"
export default class extends Controller {
    static targets = ["template", "target", "optionTemplate", "optionsTarget", "optionsContainer"]

    connect() {
        // Initialize the form
    }

    add(event) {
        event.preventDefault()

        // Get the template content
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())

        // Append the content to the target
        this.targetTarget.insertAdjacentHTML('beforeend', content)

        // Initialize any new elements that need JavaScript
        this.initializeNewElements()
    }

    remove(event) {
        event.preventDefault()

        const item = event.target.closest(".nested-fields")

        // If it's a new record, remove it from the DOM
        if (item.dataset.newRecord) {
            item.remove()
        } else {
            // Otherwise, mark it for destruction
            const input = item.querySelector("input[name*='_destroy']")
            input.value = 1
            item.style.display = 'none'
        }
    }

    addOption(event) {
        event.preventDefault()

        // Find the closest options container
        const optionsContainer = event.target.closest(".options-container")
        const optionsTarget = optionsContainer.querySelector("[data-nested-form-target='optionsTarget']")
        const optionTemplate = optionsContainer.querySelector("[data-nested-form-target='optionTemplate']")

        if (optionTemplate && optionsTarget) {
            // Get the template content
            const content = optionTemplate.innerHTML.replace(/NEW_OPTION/g, new Date().getTime())

            // Append the content to the target
            optionsTarget.insertAdjacentHTML('beforeend', content)
        }
    }

    removeOption(event) {
        event.preventDefault()

        const item = event.target.closest(".nested-option-fields")

        // If it's a new record, remove it from the DOM
        if (item.dataset.newRecord) {
            item.remove()
        } else {
            // Otherwise, mark it for destruction
            const input = item.querySelector("input[name*='_destroy']")
            input.value = 1
            item.style.display = 'none'
        }
    }

    toggleOptions(event) {
        const questionType = event.target.value
        const optionsContainer = event.target.closest(".nested-fields").querySelector(".options-container")

        if (questionType === "options") {
            optionsContainer.style.display = "block"
        } else {
            optionsContainer.style.display = "none"
        }
    }

    initializeNewElements() {
        // Add any initialization for new elements here
        // For example, you might need to initialize select2 or other libraries
    }
}